import { Locale, type LocalizedString } from "../Locale.js";

export const forgotPasswordPathMap = {
	[Locale.cs]: "zapomenute-heslo" as const,
} satisfies LocalizedString;
